import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { BillingEntity } from 'src/features/billingEntity/utils/types';
import UpdateBillingEntityFormModal from 'src/features/billingEntity/components/forms/UpdateBillingEntityFormModal';
import { billingMessages } from 'src/features/billingEntity/utils/messages';

export default function CellBillingEntityActions({ row }: CellContext<BillingEntity, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateBillingEntityFormModal
                        semantics={{ entryName: formatMessage(billingMessages.billingEntity).toLowerCase() }}
                        selectedBillingEntity={row.original}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateBillingEntityFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
